import { useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { Menu } from '../Menu'
import s from './WordTemplates.scss'
import Select from 'react-select'
import { getBaseUrl, makeGetRequest } from 'utils/api'
import cn from 'classnames'
import { useLoading } from 'hooks'

const WordTemplates = ({
  setSelectedTemplate,
  selectedTemplate,
  userWordTemplates,
  iDealWordTemplates
}) => {
  const [page, setPage] = useState(selectedTemplate?.subtype ?? 'ideal')
  const [, withLoadingLocks] = useLoading()
  return (
    <div className={s.wrapper}>
      <Container>
        <Row>
          <Col lg="2">
            <Menu page={page} setPage={setPage} />
          </Col>
          <Col lg="10">
            {page === 'yours' ? (
              <Select
                value={selectedTemplate?.subtype === 'yours' ? selectedTemplate.value : null}
                onChange={async value => {
                  const { content } = await withLoadingLocks(
                    makeGetRequest(`/v1/proposaltemplates/${value.id}`)
                  )
                  setSelectedTemplate(() => ({
                    proposalType: 'WORD',
                    subtype: 'yours',
                    value: { ...value, content }
                  }))
                }}
                options={userWordTemplates}
                className={s.select}
              />
            ) : (
              <>
                <h6>Click to select a template</h6>
                <div className={s.thumbnailsWrapper}>
                  <div className={s.list}>
                    {iDealWordTemplates.map(template => (
                      <div
                        onClick={() =>
                          setSelectedTemplate(() => ({
                            proposalType: 'WORD',
                            subtype: 'ideal',
                            value: template
                          }))
                        }
                        key={template.id}
                        className={s.thumbnail}
                      >
                        <img
                          className={cn(s.image, {
                            [s.selected]: template?.id === selectedTemplate?.value.id
                          })}
                          src={getBaseUrl(template.thumbnailUrl)}
                        />
                        <p className={s.title}>{template.title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default WordTemplates
